import { Suspense } from 'react';
import { loadable } from '@direct-frontend/modules-render';
import { PageStub } from '#shared/components/PageStub';

const AddonsAsyncLazy = loadable(() => import(/* webpackChunkName: "Addons" */ './AddonsSuspense'));

export const AddonsAsync = () => (
    <Suspense fallback={<PageStub />}>
        <AddonsAsyncLazy />
    </Suspense>
);
